import {LockOutlined, UserOutlined} from '@ant-design/icons';
import {Button, Form, Input} from 'antd';
import {inject, observer} from 'mobx-react';
import React from 'react';
import {Link} from 'react-router-dom';

const AuthForm = (props) => {
  const {router, auth} = props.store;
  const isNew = router.location.pathname === '/auth/sign_up';
  const [form] = Form.useForm();
  const handleSubmit = async (values) => {
    try {
      await auth.authenticate(values, isNew);
    } catch (error) {
      form.setFields([
        {
          name: 'email',
          value: values.email,
          errors: [error]
        }
      ]);
    }
  };
  return (
    <Form onFinish={handleSubmit} className="login-form" form={form}>
      <Form.Item name="email" rules={[{required: true, type: 'email'}]}>
        <Input
          size="large"
          prefix={<UserOutlined style={{color: 'rgba(0,0,0,.25)'}} />}
          placeholder="Email"
        />
      </Form.Item>
      <Form.Item name="password" rules={[{required: true}]}>
        <Input
          size="large"
          prefix={<LockOutlined style={{color: 'rgba(0,0,0,.25)'}} />}
          type="password"
          placeholder="Password"
        />
      </Form.Item>
      <Form.Item>
        <Button
          size="large"
          type="primary"
          htmlType="submit"
          className="login-form-button"
          loading={auth.loading}>
          {isNew ? 'Sign Up' : 'Log in'}
        </Button>
      </Form.Item>
      <div>
        Or{' '}
        {isNew ? (
          <Link to="/auth/login">log in!</Link>
        ) : (
          <Link to={`/auth/sign_up`}>sign up now!</Link>
        )}
      </div>
    </Form>
  );
};

const connectedForm = inject('store')(observer(AuthForm));

export default connectedForm;
